import {
    Dropdown,
    IconButton,
    Menu,
    MenuItemProps,
    useTranslationLang,
} from "@bsm/component";
import { useLangMenuItems } from "components/layout/hooks/useLangMenuItems";
import { useCallback, useMemo, useState } from "react";

export const LanguageMenu = () => {

    const [anchorEl, setAnchorEl] = useState<HTMLAnchorElement>();
    const translationLang = useTranslationLang();
    const languageItems = useLangMenuItems();

    const currentLang = translationLang.lang || "en";

    const handleClick = useCallback(
        (item: MenuItemProps) => {
            if (["fr", "en"].includes(item.ke!)) {
                translationLang.setLang(item.ke as string);
                setAnchorEl(undefined);
            }
        },
        [translationLang]
    );

    const currentFlag = currentLang === "fr" ? "/assets/menuFlags/menu_fr.png" : "/assets/menuFlags/menu_en.png";

    return (
        <div>
            <a
                href="#"
                data-testid="language-link"
                onClick={(e) => {
                    e.preventDefault();
                    setAnchorEl(e.currentTarget);
                }}
            >
                <div className="relative flex items-center">
                    <div className="flex items-center justify-center w-10 h-10 hover:bg-gray-50 transition-colors">
                        <img src={currentFlag} alt={currentLang} className="w-full h-full object-cover" />
                    </div>
                </div>
            </a>

            <Dropdown
                anchorEl={anchorEl}
                arrow
                placement="bottom-end"
                onClose={() => setAnchorEl(undefined)}
            >
                <Menu
                    name="language-menu"
                    items={languageItems}
                    onClick={handleClick}
                />
            </Dropdown>
        </div>
    );
};